import { render } from "./MentionsLegales.vue?vue&type=template&id=4cde841e&scoped=true"
import script from "./MentionsLegales.vue?vue&type=script&lang=js"
export * from "./MentionsLegales.vue?vue&type=script&lang=js"

import "./MentionsLegales.vue?vue&type=style&index=0&id=4cde841e&scoped=true&lang=scss"
/* hot reload */
if (module.hot) {
  script.__hmrId = "4cde841e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4cde841e', script)) {
    api.reload('4cde841e', script)
  }
  
  module.hot.accept("./MentionsLegales.vue?vue&type=template&id=4cde841e&scoped=true", () => {
    api.rerender('4cde841e', render)
  })

}


import exportComponent from "/data/tfs-agent-build-2/agent/_work/4/s/30-Frontend/Frontend/app/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cde841e"],['__file',"src/components/MentionsLegales.vue"]])